// My Surveys

<template>
<div class="lms2010 container whitesmoke curved">

  <div class="content board whitesmoke">
    <Ul class="crumbs text-charcoal mb-2">
      <li><sym-link to="/">Home</sym-link></li>
      <li><sym-link to="lms1030">Portal</sym-link></li>
      <li><span aria-current="page">My Surveys</span></li>
    </Ul>

    <div class="page-title lams curved border-lightgray mb-4">
      <h5 class="serif mb-0"><i class="fa fa-clone fa-lg ml-1 mr-2"></i>My Surveys</h5>
    </div>

    <div class="text-center mb-2" >
      <sym-combo v-model="regionId" :input-width="68" display-field="regionFullName" :datasource="regions" @changing="onRegionIdChanging" @changed="onRegionIdChanged"></sym-combo>
    </div>

    <sym-alert class="danger-light lg-2" icon="warning" v-show="isRegionListLoaded && regions.length < 2">
      <p>Your account is not authenticated by any of the LMB Regional Offices. Until then, you cannot monitor the
         status of your submitted surveys. Two (2) ways to have yours authenticated:
      </p>
      <ol>
        <li class="mb-2">Upload your next surveys via this website, Your account is automatically recognized by
            the Regional Office after successful submission.
        </li>
        <li>Upload the eSurveyPlan license file(s) issued to you by LMB via the 'Authentication' tab
            of the Geodetic Engineer Portal page.
        </li>
      </ol>
    </sym-alert>

    <div class="surveys border-main curved-1 white" v-show="surveys.length">
      <sym-card v-for="(survey, index) in surveys" :key="index" :headerClass="getCardHeaderClass(survey)" bodyClass="mintcream" class="honeydew border-main shadow-soft curved-1 mb-2">
        <div slot="header">
          <div class="d-flex justify-between align-items-start mb-1">
            <p class="lg-1 mb-0" v-if="survey.transactionId">Transaction: <span class="display-9 bold">{{ survey.transactionId }}</span></p>
            <p class="lg-1 mb-0" v-if="!survey.transactionId">DLSD: <span class="display-9 bold">{{ survey.dlsdId }}</span></p>
            <span class="lg-1 bold mr-1">{{ survey.trxStatusDescription }}</span>
          </div>

          <div class="header-2 d-flex justify-between align-items-center">
            <span>{{ core.toDateDisplayFormat(survey.submitDate) }}</span>
            <button type="button" class="info px-3 py-1 sm-2 shadow" v-if="survey.transactionId" @click="onShowRoutings(survey.transactionId)">Details</button>
          </div>
        </div>

         <ul class="text-charcoal survey-info">
          <li class="list-item p-2">
            <p class="-mt-1 mb-2 bold"><span class="sm-2">Requested Lot</span></p>
            <p class="info-value">{{ survey.requestedLot }}</p>
          </li>
          <li class="list-item p-2">
            <p class="-mt-1 mb-2 bold"><span class="sm-2">Location</span></p>
            <p class="info-value">{{ survey.requestedLocation }}</p>
          </li>
          <li class="list-item p-2">
            <p class="-mt-1 mb-2 bold"><span class="sm-2">Client Name</span></p>
            <p class="info-value">{{ survey.clientName }}</p>
          </li>
        </ul>
      </sym-card>

    </div>

    <button type="button" class="primary text-center w-100 lg-1 shadow mt-3 mb-2" @click="go('lms1030')"><i class="fa fa-arrow-left mr-2"></i> Back to GE Portal </button>

  </div>

  <sym-modal
    v-model="isModalVisible"
    size="lg"
    :header="false"
    :customBody="true"
    :footer="false"
    :backdrop="false"
    v-if="isModalVisible"
  >
    <div class="p-1 mb-0">
      <div class="curved border-dark lams-light p-2 text-center">
        <p class="lams p-2 curved-top mb-0 lg-2">Details of Transaction: <span class="bold display-9">{{ routings[0].transactionId }}</span></p>

        <table class="mb-2 table-scroll">
          <thead>
            <tr class="text-charcoal">
              <th class="w-15">Date / Time</th>
              <th class="w-20">Workgroup</th>
              <th class="w-20">Assigned To</th>
              <th class="w-10">Status</th>
              <th class="w-20">Task</th>
              <th class="w-15">Remarks</th>
            </tr>

          </thead>

          <tbody class="white text-charcoal">
            <tr v-for="(routing, index) in routings" :key="index">
              <td>{{ core.toDateFormat(routing.createDate, true, 'dd MMM yyyy h:mmtt') }}</td>
              <td>{{ routing.workgroupDescription }}</td>
              <td>{{ routing.userName }}</td>
              <td>{{ routing.trxStatusDescription }}</td>
              <td>{{ routing.action }}</td>
              <td>{{ routing.remarks }}</td>
            </tr>
          </tbody>
        </table>

        <button type="button" class="warning w-100 text-center shadow lg-3 p-1 my-2" @click="isModalVisible=false">Close</button>

      </div>
    </div>
  </sym-modal>

</div>
</template>

<script>

import {
  get
} from '../../js/http';

import
  PageBase
from '../PageBase.vue';

export default {
  extends: PageBase,
  name: 'lms2010',

  data () {
    return {
      regions: [],
      regionId: 0,
      surveys: [],
      surveyorId: 0,

      routings: [],

      isRegionListLoaded: false,
      isModalVisible: false

    };
  },

  methods: {

    // API calls

    getRegions () {
      return get('api/accounts/' + this.accountCode + '/regions-surveyor');
    },

    getLinkStatus (regionId) {
      return get('api/regions/' + regionId + '/link-status');
    },

    getSubmissions () {
      return get('api/rgn/' + this.regionId + '/surveyors/' + this.surveyorId + '/submissions');
    },

    getRoutings (transactionId) {
      return get('api/rgn/' + this.regionId + '/transactions/' + transactionId + '/routings');
    },

    // event handlers

    onRegionIdChanging (e) {
      const me = this;

      let regionInfo = me.regions.find( obj => obj.regionId === e.proposedValue );
      e.message = `Region '${regionInfo.regionFullName}' is offline.`;

      if (!regionInfo.apiHostAddress && regionInfo.regionId) {
        e.preventDefault();
        return;
      }

      if (e.proposedValue) {
        e.surveyorId = regionInfo.surveyorId;   // dynamic property
        e.callback = me.regionIdCallback;
      }

    },

    regionIdCallback (e) {
      const
        me = this,
        wait = me.wait();

      return me.getLinkStatus(e.proposedValue).then(
        statusCode => {
          me.stopWait(wait);

          let isOnline = (statusCode === 200);
          if (isOnline) {
            me.surveyorId = e.surveyorId;
          } else {
            me.surveyorId = 0;
          }
          return isOnline;
        },
        () => {
          me.stopWait(wait);
          return false;

        }
      );

    },

    onRegionIdChanged () {
      const me = this;

      if (!me.regionId) {
        me.surveys = [];
        return;
      }

      let wait = me.wait();

      me.getSubmissions().then(
        surveys => {
          me.stopWait(wait);
          me.surveys = surveys;
        },
        fault => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );

    },

    onShowRoutings (transactionId) {
      const
         me = this,
         wait = me.wait();

      me.getRoutings(transactionId).then(
        routings => {
          me.stopWait(wait);
          me.routings = routings;
          me.isModalVisible = true;
        },
        fault => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );

    },

    // helpers

    getCardHeaderClass (survey) {

      if (!survey.transactionId) {
        return 'beige';
      }
      if (survey.trxStatusId === 'P') {
        return 'primary-light';
      }
      return '';

    }

  },

  created () {
    this.accountCode = '';
  },

  mounted () {
    const me = this;

    me.accountCode = me.sym.userInfo.accountCode;

    me.getRegions().then(
      regions => {
        regions.unshift(
          { regionId: 0, regionFullName: '--- Select Region ---', surveyorId: 0, apiHostAddress: null }
        );
        me.regions = regions;
         // error when disconnected to region       
        // if (regions.length === 2) {
        //   me.regionId = regions[1].regionId;
        //   me.surveyorId = regions[1].surveyorId;
        //   me.onRegionIdChanged();
        // }
        me.isRegionListLoaded = true;
      },
      fault => {
        me.showFault(fault);
      }
    );

  }

}

</script>

<style scoped>

/* .lms2010 {
  min-height: calc(100vh - 90px - 2rem) ;
} */

.page-title {
  padding: .875rem;
}

.surveys {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  padding: 1rem;
}

.survey-info .info-value {
  color: brown;
  margin-bottom: 0;
  font-size: 1rem;
  line-height: 1.1;
}

.survey-info .list-item{
  background: white;
}

.header-2 {
  line-height: 1.9;
}

.table-scroll {
  overflow-x: auto;
  white-space: nowrap;
  display: block;
}

td {
  vertical-align: top;
}

.alert li {
  margin-left: 1.125em;
}

@media (max-width: 1024px) {
  .content {
    padding: 1.25rem;
  }
}

@media (max-width: 976px) {
  .content {
    padding: 1rem;
  }
  .surveys >>> .card-body {
    padding: 1rem;
  }
}

@media (max-width: 870px) {
  .surveys {
    grid-template-columns: 1fr;
  }

}

/* @media (max-width: 576px) {
  .lms2010 {
    min-height: calc(100vh - 84px) ;
  }
} */

@media (max-width: 480px) {
  .surveys {
    padding: .5rem;
  }
  .surveys >>> .card-body {
    padding: .25rem;
  }
}

@media (max-width: 394px) {
  .content {
    padding: .5rem;
  }
}

@media (max-width: 320px) {
  .content {
    padding: .25rem;
  }

  .surveys >>> .card-body {
    padding: .125rem;
  }

}

</style>